import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map, take, tap } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { pickBy } from 'src/app/core/helpers/object.helper';
import { ProductCard } from '../models/product-card.model';
import { SearchFilter } from '../models/search-filter.model';
import { SearchPagination } from '../models/search-pagination.model';
import { SearchResultResponse } from '../models/search-result.model';

@Injectable({ providedIn: 'root' })

export class BrokerProfileService {
  products$ = new BehaviorSubject<ProductCard[]>([]);
  pagination$ = new BehaviorSubject<SearchPagination>(null);
  loading$ = new BehaviorSubject<boolean>(false);
  filter = new SearchFilter();
  private uri = this.environmentService.getEnvVar('api_profile');

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  getBrokerProducts(nickname: string, pg?: number): Observable<Array<ProductCard>> {
    const api = `${this.uri}/profile/${nickname}/products/summary`;
    this.loading$.next(true);
    const currentPage = pg ? pg : (this.filter.page >= 0 ? this.filter.page - 1 : 0);
    const {...params} = {
      ...this.getParamsToUrl(),
      page: currentPage,
    } as any;
    const urlPrams = this.getQueryParams(params);
    return this.http.get<SearchResultResponse>(`${api}?${urlPrams}`)
    .pipe(
      tap(res => this.paginationHandler(res, this.getBrokerProducts, params.page)),
      map(res => res ? res.products.content.map(p => new ProductCard(p)) : []),
      finalize(() => this.loading$.next(false)),
      catchError(this.errorHandlerGeneric)
    );
  }

  getQueryParams(filters = this.getParamsToUrl()) {
    return Object.entries(filters).map(([key, val]) => {
      if (Array.isArray(val)) {
        return  val.map(v => `${key}=${v}`).join('&');
      }
      return `${key}=${val}`;
    }).join('&');
  }


  getParamsToUrl(params = this.filter.getFilterParams() as any) {
    if (params.divisionUnitTypes && params.divisionUnitTypes.length > 0) {
      params.divisionUnitTypes = params.divisionUnitTypes.map(value => value.toLowerCase());
    }
    return this.filterParamsToUrlParams(
      pickBy(params )
    );
  }

  filterParamsToUrlParams(params) {
    const urlParams = {};
    // tslint:disable-next-line: forin
    for (const key in params) {
      urlParams[key] = Array.isArray(params[key])
        ? params[key]
        : [params[key]];
    }
    return urlParams;
  }

  paginationHandler = (res: any, method: (...a) => Observable<any>, ...args) => {
    const products = res ? res.products : {
      last: false,
      first: false,
      totalPages: 0,
      numberOfElements: 0,
      size: 0,
      number: 0,
      totalElements: 0
    };

    this.pagination$.next({
      last: products.last,
      first: products.first,
      totalPages: products.totalPages,
      numberOfElements: products.numberOfElements,
      size: products.size,
      number: this.filter.page || 1,
      totalElements: products.totalElements,
      method: (nickname, page) => {
        args = [nickname, this.filter.url, this.filter.page];
        method.apply(this,  [...args, false])
          .pipe(
            take(1)
          ).subscribe();
      }
    });
  }

  errorHandlerGeneric = (error): Observable<any> => {
    this.loading$.next(false);
    return of([]);
  }
}
